import { render, staticRenderFns } from "./AppGoodActive.vue?vue&type=template&id=1b50430f&scoped=true&"
import script from "./AppGoodActive.vue?vue&type=script&lang=js&"
export * from "./AppGoodActive.vue?vue&type=script&lang=js&"
import style0 from "./AppGoodActive.vue?vue&type=style&index=0&id=1b50430f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b50430f",
  null
  
)

export default component.exports